/** Recipients as the text box shows them: one address per line. */
export const recipientsToText = (recipients: string[]) => recipients.join("\n");

/** The text box's addresses: split on lines, commas, semicolons or spaces, blanks dropped. */
export const recipientsFromText = (text: string) => text.split(/[\s;,]+/).filter(Boolean);
